import { makeStyles } from '@hawkins/styles';

export const formFields = makeStyles({
  row: {
    marginBottom: '0.25vmax !important',
  },
});
